/** Granular keys that map to one consolidated assignable permission. */
export const ISF_CONSOLIDATED_PERMISSION_LEGACY = {
  FOLDER_LIBRARY: [
    "VIEW_FOLDER_LIBRARY",
    "ADD_FOLDER_LIBRARY",
    "EDIT_FOLDER_LIBRARY",
    "DELETE_FOLDER_LIBRARY",
  ],
  MILESTONE_LIBRARY: [
    "VIEW_MILESTONE_LIBRARY",
    "ADD_MILESTONE",
    "EDIT_MILESTONE",
    "DELETE_MILESTONE",
    "MANAGE_MILESTONE_LIBRARY",
  ],
  MILESTONE_PLAN: [
    "VIEW_MILESTONE_PLAN",
    "ADD_MILESTONE_PLAN",
    "EDIT_MILESTONE_PLAN",
    "DELETE_MILESTONE_PLAN",
    "MANAGE_MILESTONE_PLAN",
  ],
  TEMPLATE_MANAGER: [
    "VIEW_TEMPLATE",
    "ADD_TEMPLATE",
    "UPDATE_TEMPLATE",
    "DELETE_TEMPLATE",
    "MANAGE_TEMPLATE_PLACEHOLDERS",
  ],
  AUDIT_LOG: ["DOWNLOAD_AUDIT_LOG", "REQUEST_AUDIT_LOG"],
};

/**
 * Promote legacy View/Add/Edit/Delete eISF keys to the consolidated permission.
 * When stripLegacy is true (role/user UI), remove the old keys so only one checkbox is stored.
 */
export function expandStoredIsfPermissionKeys(
  permissionKeys = [],
  { stripLegacy = true } = {},
) {
  const result = new Set(
    (permissionKeys || [])
      .map((key) => String(key || "").trim())
      .filter(Boolean),
  );

  for (const [canonicalKey, legacyKeys] of Object.entries(
    ISF_CONSOLIDATED_PERMISSION_LEGACY,
  )) {
    const hasCanonical = result.has(canonicalKey);
    const hasLegacy = (legacyKeys || []).some((key) => result.has(key));
    if (hasCanonical || hasLegacy) {
      result.add(canonicalKey);
      if (stripLegacy) {
        (legacyKeys || []).forEach((key) => result.delete(key));
      }
    }
  }

  return Array.from(result);
}
